<template>
  <div>
    <template v-if="!disabled && options && options.length " >
      <el-select
        v-if="!isMobile"
        ref="owlSelect"
        v-model="_value"  
        filterable 
        :filter-method="inputFilterWords"
        clearable
        :default-first-option="allowCreate"
        :allow-create="allowCreate"
        :placeholder="placeholder || t('stuManagement.pleaseSelect')"
        @change="handleChange"
        @clear="handleClear"
        @visible-change="onSwitchDrop"
      >
        <div :class="['owl-select-wrap', options.length<=40 && 'no-pagination']">
          <el-option 
            v-for="(item, index) in filterOptions"
            :label="item[optionConfig.label]"
            :key="getOptionRenderKey(item, index)"
            :value="item[optionConfig.value]"
          ></el-option>
          <div class="pagination-wrap">
            <i class="left-arrow" title="Previous page" @click="toPage(currentPage-1)"></i>
            <span @click="toPage(1)" :class="['number', currentPage == 1 && 'active']">1</span>
            <span class="number" v-show="currentPage>3">...</span>
            <span @click="toPage(currentPage-1)" class="number" v-show="currentPage>2">{{currentPage-1}}</span>
            <span class="number active" v-show="currentPage != 1 && currentPage != lastPage">{{currentPage}}</span>
            <span @click="toPage(currentPage+1)" class="number" v-show="currentPage + 1 < lastPage">{{currentPage+1}}</span>
            <span class="number" v-show="currentPage + 2 <lastPage">...</span>
            <span @click="toPage(lastPage)" :class="['number', currentPage == lastPage && 'active']" v-show="lastPage>1">{{lastPage}}</span>
            <i class="right-arrow" title="Next page" @click="toPage(currentPage+1)"></i>
          </div>
        </div>
      </el-select>
      <owl-mobile-select 
        v-else-if="isMobile && !isMobileCanSearch"
        v-model="_value"
        :placeholder="placeholder || t('stuManagement.pleaseSelect')"
        :options="options"
        :optionConfig="optionConfig"
      />
      <owl-mobile-select-page
        v-else-if="isMobile && isMobileCanSearch"
        v-model="_value"
        :placeholder="placeholder || t('stuManagement.pleaseSelect')"
        :options="options"
        :optionConfig="optionConfig"
      ></owl-mobile-select-page>
    </template>
    <el-input :disabled="isDisable" v-else-if="!disabled && (!options || !options.length)" v-model="_value"/>
    <div v-else-if="disabled" class="label" v-html="((options && options.length) ? label || _value  : _value)|| '&nbsp;'"></div>
  </div>
</template>
<script>
import i18n from "@/locale/index";
import OwlMobileSelect from './OwlMobileSelect.vue';
import OwlMobileSelectPage from './OwlMobileSelectPage.vue';
export default {
  components:{
    OwlMobileSelect,
    OwlMobileSelectPage,
  },
  mixins: [i18n],
  model:{
    prop: "value",
    event: "change"
  },
  props: {
    isDisable: {
      type: Boolean,
      default: false,
    },
    needOption: {
      type: Boolean
    },
    value: {
      type: [Number,String,Boolean]
    },
    searchKey: {
      default: 'label'
    },
    disabled: {
      type: Boolean
    },
    optionConfig: {
      type: Object,
      require: false,
      defalut: {
        label: "label",
        value: "value"
      }
    },
    options: {
      type: Array,
    },
    allowCreate: {
      type: Boolean,
      require: false,
      defalut: false
    },
    englishOnly:{
      type: Boolean,
      default: true,
      require: false,
    },
    placeholder: String,
    // 移动端显示pc下拉
    isMobileCanSearch: {
      type: Boolean,
      require: false,
      defalut: false
    }
  },
  data(){
    return {
      currentPage: 1,
      keywords: '',
      filterOptions: [],
      lastPage: 1,
    }
  },
  watch:{
    options: {
      handler(newVal){
        if(!newVal || !newVal.length) {
          this.currentPage = 1;
          this.filterOptions = [];
          this.lastPage = 1;
          return;
        }
        this.resetOptionsByValue(newVal, this.value);
      },
      deep: true,
      immediate: true
    },
    value(newVal){
      // 可搜索下拉输入时可能先更新 v-model，再执行过滤；
      // 此时不要让外部值更新恢复未过滤的选项列表。
      if(this.keywords || !this.options || !this.options.length) return;
      this.resetOptionsByValue(this.options, newVal);
    }
  },
  computed:{
    label(){
      if(!this.options || this.options.length == 0) return "";
      const item = this.options.find(item=> item[this.optionConfig.value] == this.value)
      return item ? item[this.optionConfig.label] : ""
    },
    _value:{
      get(){
        return this.value
      },
      set(val){
        if(this.englishOnly && val !== null && val !== undefined ){
          if (val.toString().match(/[\u4e00-\u9fa5]/)) {
            val = val.toString().replace(/[\u4e00-\u9fa5]/g, '');
            this.$msge.error(this.t('validate.onlyEnlishInput'));
          }
          if(val.toString().match(/[。，！？·【】—《》‘’“”、；：|]/)){
            val = val.toString().replace(/[。，！？·【】—《》‘’“”、；：|]/g, '');
            this.$msge.error(this.t('validate.pleaseEnPunctuation'));
          }
        }
        this.keywords = '';
        this.$emit("change", val);
        if (this.needOption) {
          const option = this.filterOptions.filter((item) => item[this.optionConfig.value] === val);
          this.$emit("getOption", option[0]);
        }
      }
    },
    isMobile(){
      return this.$isMobile();
    }
  },
  methods:{
    // 生成稳定且不重复的 option key，避免筛选后复用异常
    getOptionRenderKey(item, index){
      return `${item[this.optionConfig.value]}-${index}`;
    },
    // 按当前值重算分页，并刷新当前页的候选项
    resetOptionsByValue(list, value){
      let index = list.findIndex(item=>item[this.optionConfig.value] == value);
      this.currentPage = index > 0 ? Math.ceil((index + 1) / 40) : 1;
      this.lastPage = Math.max(Math.ceil(list.length / 40), 1);
      this.filterOptions = list.slice((this.currentPage-1)*40, this.currentPage*40);
    },
    // 主动清掉 el-select 内部搜索状态，避免二次搜索时残留旧 query
    resetSelectState(){
      const selectRef = this.$refs.owlSelect;
      if(!selectRef) return;
      if(typeof selectRef.query !== 'undefined'){
        selectRef.query = '';
      }
      if(typeof selectRef.previousQuery !== 'undefined'){
        selectRef.previousQuery = null;
      }
      if(typeof selectRef.hoverIndex !== 'undefined'){
        selectRef.hoverIndex = -1;
      }
      if(typeof selectRef.selectedLabel !== 'undefined'){
        selectRef.selectedLabel = this.label || '';
      }
      if(selectRef.broadcast){
        selectRef.broadcast('ElOption', 'queryChange', '');
      }
    },
    // 记录输入的搜索词，并从第一页开始筛选
    inputFilterWords(val){
      this.keywords = val;
      this.currentPage = 1;
      this.getFilterOptions();
    },
    // 根据搜索词过滤选项，同时维护分页信息
    getFilterOptions(){
      let list = [];
      if(!this.keywords){
        list = this.options;
      } else {
        list = this.options.filter(item => 
          item[this.optionConfig[this.searchKey]] && item[this.optionConfig[this.searchKey]].toString().toLowerCase().indexOf(this.keywords.toLowerCase())>=0
        )
      }
      this.lastPage = Math.max(Math.ceil(list.length / 40), 1)
      this.filterOptions = list.slice((this.currentPage-1)*40, this.currentPage*40)
    },
    // 切换分页时同步刷新当前页数据
    toPage(next){
      if(next < 1) {
        this.currentPage = 1;
      } else if (next > this.lastPage){
        this.currentPage = this.lastPage
      } else {
        this.currentPage = next;
      }
      this.getFilterOptions();
    },
    // 选中后同步清理内部搜索状态，避免下次展开异常
    handleChange(){
      this.resetSelectState();
    },
    // 清空后重置筛选和分页，保证可以重新搜索和选择
    handleClear(){
      this.keywords = '';
      this.options && this.resetOptionsByValue(this.options, '');
      this.$nextTick(()=>{
        this.resetSelectState();
      });
    },
    // 下拉展开或关闭时都重置搜索态，避免 query 残留影响交互
    onSwitchDrop(visible){
      if(visible){
        this.keywords = '';
        this.options && this.resetOptionsByValue(this.options, this.value);
        return;
      }
      this.keywords = '';
      this.options && this.resetOptionsByValue(this.options, this.value);
      this.resetSelectState();
    }
  }
}
</script>

<style lang="scss" scoped>
.owl-select-wrap{
  padding-bottom: 36px;
  &.no-pagination{
    padding-bottom: 0;
    .pagination-wrap{
      display: none;
    }
  }
  .pagination-wrap{
    position: absolute;
    height: 34px;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 20px;
    justify-content: center;
    cursor: pointer;
  }
  .left-arrow{
    width: 10px;
    height: 10px;
    border: 2px solid #999;
    transform: rotate(-45deg);
    border-right: 0;
    border-bottom: 0;
    border-radius: 2px;
    transition: border-color .25s;
    margin-right: 18px;
    cursor: pointer;
    &:hover{
      border-color: #ff9700; 
      border-color: var(--form-color-primary);
    }
  }
  .right-arrow{
    border-radius: 2px;
    transition: border-color .25s;
    width: 10px;
    height: 10px;
    border: 2px solid #999;
    border-left:0;
    border-bottom: 0;
    transform: rotate(45deg);
    margin-left: 12px;
    &:hover{
      border-color: #ff9700; 
      border-color: var(--form-color-primary);
    }
    }
    .number{
    width: fit-content;
    height: 20px;
    // padding: 0 4px;
    margin-right: 6px;
    font-size: 14px;
    line-height: 1;
    text-align: center;
    color: #333;
    &.active{
      color: #ff9700; 
      color: var(--form-color-primary);
      font-weight: bold;
    }
    &:hover{
      color: #ff9700; 
      color: var(--form-color-primary);
    }
  }
}
</style>
